module.exports = __webpack_public_path__ + "img/house.d7cd47a6.png";